import { EmptyState } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

interface NoDataComponentProps {
    title: string;
    subtitle: string;
}

const NoDataComponent: React.FC<NoDataComponentProps> = ({ title, subtitle }) => (
    <EmptyState
        title={title}
        subtitle={subtitle}
        className={"noDataTable"}
    />
);
export const getNoDataObject = (isError: boolean) => ({
    Component: () => (
        <NoDataComponent
            title={translate(
                isError
                    ? "keyword.research.search.ads.table.error.title"
                    : "keyword.research.search.ads.table.no.data.title",
            )}
            subtitle={translate(
                isError
                    ? "keyword.research.search.ads.table.error.subtitle"
                    : "keyword.research.search.ads.table.no.data.subtitle",
            )}
        />
    ),
});
